var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13183_106158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.28 9.38928L9.39001 13.2793C9.24939 13.4197 9.05876 13.4986 8.86001 13.4986C8.66126 13.4986 8.47064 13.4197 8.33001 13.2793L0.610013 5.55928C0.571222 5.5222 0.541213 5.47691 0.52218 5.42673C0.503148 5.37656 0.495574 5.32276 0.500013 5.26928L1.09001 1.43928C1.09483 1.34802 1.13325 1.26176 1.19787 1.19714C1.26249 1.13251 1.34875 1.09409 1.44001 1.08928L5.27001 0.499281C5.32349 0.494842 5.37729 0.502415 5.42747 0.521448C5.47764 0.54048 5.52293 0.57049 5.56001 0.609281L13.28 8.32928C13.4205 8.46991 13.4994 8.66053 13.4994 8.85928C13.4994 9.05803 13.4205 9.24866 13.28 9.38928V9.38928Z",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.11011 4.60938C4.38625 4.60938 4.61011 4.38552 4.61011 4.10938C4.61011 3.83323 4.38625 3.60938 4.11011 3.60938C3.83397 3.60938 3.61011 3.83323 3.61011 4.10938C3.61011 4.38552 3.83397 4.60938 4.11011 4.60938Z",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13183_106158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRole);
export default __webpack_public_path__ + "static/media/role.e1b280a896cacbd349a223eaa46f8476.svg";
export { ForwardRef as ReactComponent };